import Base from "@/plugins/Base";

const module = {
    namespaced: true,
    state: () => ({
        pcgc_id: null
    }),
    getters: {
        getId(state){
            return state.pcgc_id
        },
    },
    mutations: {
        setId(state, pcgc_id){
            state.pcgc_id = pcgc_id
        },
        clearData(state){
            state.pcgc_id = null
        },
    },
    actions: {
        setPcgcId({commit, dispatch}, data) {
            Base.LocalStorage.set('pcgc_id',data)
            dispatch("initPcgc")
        },

        initPcgc({commit, dispatch}) {
            let pcgcId = Base.LocalStorage.get('pcgc_id')
            if(pcgcId){
                commit("setId", pcgcId)
            }
        },

        removeData({commit}) {
            commit("clearData")
            Base.LocalStorage.remove('pcgc_id')
        },
    }

}

export default module;
